import Logo from './Logo';

const EXPORT = {
  Logo,
};

export default EXPORT;
